import{a as e,b as n}from"./chunk-4RWQEYZX.js";function I(t){switch(t){case"development":case"staging":return e;case"production":return n;default:return null}}export{I as a};
